import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import Container from 'components/Container';
import Gallery from './components/GalleryList';

import { skywallethdk } from './content';


class GalleryHDK extends React.PureComponent {
  render() {
    return (
      <div>
        <Container>
          <div ref={(section) => { this.SkywalletHDK = section; }} >
            <Gallery items={skywallethdk} heading="skywallethdk.gallery.title" />
          </div>
        </Container>
      </div>
    );
  }
}

GalleryHDK.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
};

export default injectIntl(GalleryHDK);



// WEBPACK FOOTER //
// ./src/components/SkywalletHDK/components/GalleryHDK/GalleryHDK.js